import { TopicRegisterItem } from '@aipb/gulliver/catalog/model';
import { HoverHighlightDirective } from '@aipb/shared/ui/directives';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'cat-topic-register-list',
  templateUrl: './topic-register-list.component.html',
  styleUrls: ['./topic-register-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatListModule, TranslocoModule, HoverHighlightDirective]
})
export class TopicRegisterListComponent {
  @Input() items: TopicRegisterItem[] = [];
  @Input() showCount = true;

  @Output() action = new EventEmitter<TopicRegisterItem>();
}
